import React, { useState, useContext, useEffect } from "react";
import styles from "./styles/InstalmentPos.module.css";
import DataContext from "../../../context/DataContext";
import { formatDateToLocalDate } from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import { ReactComponent as Mandetory } from "../../../assets/mandetory.svg";
import POSDataContext from "../../../context/POSDataContext";
import useNumberFormat from "../../../hooks/useNumberFormat";
import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";

import { ReactComponent as IconClock } from "../../../assets/clock.svg";
import { ReactComponent as IconGavel } from "../../../assets/gavel.svg";

/**
 * SideTicket component
 */
const InstalmentPos = ({
    instalment,
    caseNo,
    currency,

    handleCheckFunction,
    selectedSettlementsPos,

    setCurrenInstalmentPos,
    clickedInstalmentPos,
    handleClickedInstalment,
    onClickHandleSettlement,
    transactionID,
}) => {
    const [isSelected, setIsSelected] = useState(false);
    const formatNum = useNumberFormat();

    const { selectedInstalmentsPos, setIsInstallemtHoverPos } =
        useContext(POSDataContext);
    useEffect(() => {
        setIsSelected(isInSelectedInstalments());
    }, [selectedInstalmentsPos]);

    const onClickHandle = () => {
        onClickHandleSettlement(true);
        setCurrenInstalmentPos(instalment);

        handleClickedInstalment(instalment?.id);
    };

    const isInSelectedInstalments = () => {
        return (
            Array.isArray(selectedInstalmentsPos) &&
            selectedInstalmentsPos.some(
                (inst) =>
                    inst.instalmentId.toString() === instalment?.id.toString()
            )
        );
    };
    const checkDisable = () => {
        return !selectedSettlementsPos.includes(caseNo);
    };
    const getStatus = () => {
        switch (instalment?.status) {
            case 0:
                return "Overdue";
            case 1:
                return "Due";
            case 2:
                return "Upcoming";
        }
    };
    const hoverfunction = (event) => {
        event.stopPropagation();
        if (event.type === "pointerenter") {
            setIsInstallemtHoverPos(
                event.target.dataset.instinfo.match(/#(\d+)/)?.[1]
            );
        } else {
            setIsInstallemtHoverPos("");
        }
    };

    return (
        <button
            className={`${styles.main_ticket_container} ${
                clickedInstalmentPos === instalment?.id
                    ? instalment?.status === 0
                        ? styles.clicked_red
                        : instalment?.status === 1
                        ? styles.clicked_yellow
                        : styles.clicked
                    : ""
            } flex-container`}
            onClick={() => onClickHandle()}
        >
            <div className={`${styles.input_check_container} flex-container`}>
                {instalment?.status === 2 ? (
                    <>
                        <input
                            onPointerEnter={(event) => hoverfunction(event)}
                            onPointerLeave={(event) => hoverfunction(event)}
                            data-instinfo={instalment?.txt}
                            data-insttransactionid={transactionID}
                            data-instalmentdate={instalment?.dateAndTime}
                            className={`${styles.input_check_element} `}
                            type="checkbox"
                            name={instalment?.id}
                            id={instalment?.id}
                            value={instalment?.netAmount || 0}
                            disabled={checkDisable()}
                            onClick={handleCheckFunction}
                            checked={!!isSelected}
                            readOnly // Prevents React warnings since we're controlling `checked`
                        />
                        <label
                            className={`${styles.input_check_label}`}
                            htmlFor={instalment?.caseNo}
                            aria-label={`Check input for settlement ${instalment?.caseNo}`}
                        ></label>
                    </>
                ) : (
                    <Mandetory
                        className={`${styles.mandetory_icon} ${
                            !checkDisable() ? styles.mandetory_icon_active : ""
                        }`}
                    />
                )}
            </div>

            <div className={`${styles.info_container} v-flex-container`}>
                <div
                    className={`${styles.ticket_info} ${styles.ticket_hide_info} ${styles.status_tag}`}
                    style={{
                        minWidth: "6rem",
                        textAlign: "left",
                    }}
                >
                    <span>
                        <IconGavel
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {getStatus()}
                </div>
                <div className={`${styles.ticket_info} ${styles.date_tag} `}>
                    <span>
                        <IconClock
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {formatDateToLocalDate(instalment?.dateAndTime)}
                </div>

                <div
                    className={`${styles.ticket_info} ${styles.ticket_hide_info_2nd} ${styles.amount_tag}
                    
                    `}
                >
                    <span>
                        <IconBill
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {`${currency}${formatNum(instalment?.netAmount)}`}
                </div>
            </div>
        </button>
    );
};

export default InstalmentPos;
